
$(document).ready(function(){
    if($('ol[style="list-style-type: upper-roman;"]').length>0) {
        $('ol[style="list-style-type: upper-roman;"]').each(function() {
            let $this = $(this);
            $this.hide();
            $this.after('<div class="products products-block product-block-posts"></div>');
            let $productContainer = $this.next('.products-block');
    
            let codes = [];
            $this.find('li span').each(function() {
                let code = $(this).text();
                if (!codes.includes(code)) {
                    codes.push(code);
                }
            });
                if (codes.length > 0) {
                    let endpoint = 'https://node-7183.rostiapp.cz/api/happyzoo/products?codes=' + codes.join(',');
    
                    $.get(endpoint, function(data) {
                        let productData = data;
                        productData.forEach(function(product) {
                            if(product.OLD_PRICE_VAT === product.PRICE_VAT){
                                var saleClass = ''
                            }
                            else{
                                var saleClass = 'discount'
                            }
                            let customProductData = '<div class="product">';
                            customProductData += '<div class="p">';
                            customProductData += '<a href="' + product.URL + '" class="image">';
                            customProductData += '<img src="' + product.IMG_URL + '" alt="' + product.NAME + '">';
                            customProductData += '</a>';
                            customProductData += '<div class="p-in">';
                            customProductData += '<div class="p-in-in">'
                            customProductData += '<a href="'+product.URL+'" class="name" data-micro="url" tabindex="0"><span data-micro="name" data-testid="productCardName">' + product.NAME + '</span></a>'
                            customProductData += '</div>'
                            customProductData += '<div class="p-bottom single-button">'
                                customProductData += '<div data-micro="offer">'
                                    customProductData += '<div class="p-tools">'
                                        customProductData += '<div class="prices '+saleClass+'">'
                                        if(product.OLD_PRICE_VAT === product.PRICE_VAT){
                                            customProductData += '<div class="price price-final" data-testid="productCardPrice"><strong>'+Number(product.PRICE_VAT).ShoptetFormatAsCurrency()+'</strong></div>'
                                        }
                                        else{
                                            customProductData += '<span class="price-standard"><span>'+Number(product.OLD_PRICE_VAT).ShoptetFormatAsCurrency()+'</span></span>'
                                            customProductData += '<div class="price price-final" data-testid="productCardPrice"><strong>'+Number(product.PRICE_VAT).ShoptetFormatAsCurrency()+'</strong></div>'
                                        }
                                        customProductData += '</div>'
                                        customProductData += '<a href="'+product.URL+'" class="btn btn-primary" tabindex="0">Detail</a>'
                                    customProductData += '</div>'
                                customProductData += '</div>'
                            customProductData += '</div>'
                            customProductData += '</div>'
                            customProductData += '</div>'
                            customProductData += '</div>'
    
                            $productContainer.append(customProductData);
                        });
                    }).done(function(){
                        
                        
                    })
                }
        });
    };
});
